import {createSlice, isAnyOf, type SliceSelectors} from '@reduxjs/toolkit'

import {getAllPointBalance, getRewardPointBalance} from '@web/actions/pointPayment'
import {restoreSavedState, restoreState} from '@web/actions/restoreState'
import {APIStatus} from '@web/core/constants'
import {getInitialState, getPoints, getRewardStatus} from '@web/slices/rewardPoint/slice'

import type {RewardPointReducers, MakeSliceOptions} from './interfaces'
import type {RewardPointState} from '@web/slices/rewardPoint/slice'

export default (options?: MakeSliceOptions) =>
    createSlice<RewardPointState, RewardPointReducers, 'rewardPoint', SliceSelectors<RewardPointState>>({
        name: 'rewardPoint',
        initialState: getInitialState(),
        reducers: {},
        extraReducers: (builder) => {
            builder
                .addCase(getAllPointBalance.fulfilled, (state, {payload}) => {
                    const {rewardPoint, cashRewardPoint} = payload
                    state.amount = rewardPoint
                    state.cashPoint = cashRewardPoint
                    state.status = getRewardStatus(payload.data.rewardPoint.success)
                })
                .addCase(getRewardPointBalance.fulfilled, (state, {payload}) => {
                    const {rewardPoint, cashRewardPoint, data} = payload
                    state.amount = rewardPoint
                    state.cashPoint = cashRewardPoint
                    state.status = getRewardStatus(payload.data.success)
                    state.descriptions = getPoints({
                        totalBalance: rewardPoint,
                        points: data.rewardPointDescriptions,
                    })
                })
            options?.extraReducers?.(builder)
            builder
                .addMatcher(isAnyOf(restoreSavedState.fulfilled, restoreState), (state, {payload}) => {
                    return payload.rewardPoint ?? state
                })
                .addMatcher(isAnyOf(getAllPointBalance.pending, getRewardPointBalance.pending), (state) => {
                    state.status = APIStatus.FETCHING
                })
                .addMatcher(isAnyOf(getAllPointBalance.rejected, getRewardPointBalance.rejected), (state) => {
                    state.status = APIStatus.REJECTED
                    state.amount = 0
                    state.cashPoint = 0
                })
        },
    })
